import { API_URL } from "../constants";
import axios from "axios";
import middleware from "../util/middleware";

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

export default class InventarioCiclicoRequest {
    static ListaArticulosIniciales(idSitio, idFrecuencia) {
        return middleware.hasAuth(() => request.get('barras/ciclicos/capturainicial', {
            params: {
                idDrive: idSitio,
                frecuencia: idFrecuencia
            }
        }))
    }

    static ListaInventarios(idSitio) {
        return middleware.hasAuth(() => request.get('barras/ciclicos/captura', {
            params: {
                sitio_id: idSitio,
            }
        }))
    }

    static GuardarBorrador(data) {
        return middleware.hasAuth(() => request.post('barras/ciclicos/captura', data))
    }

    static EliminarBorrador(idInventario) {
        return middleware.hasAuth(() => request.delete('barras/ciclicos/captura', {
            params: {
                inventario_id: idInventario,
            }
        }))
    }

    static ListarDetalleInventarioRpt(idInventario) {
        return middleware.hasAuth(() => request.get('barras/ciclicos/detalle', {
            params: {
                id: idInventario
            }
        }))
    }

    static EditarInventario(data) {
        return middleware.hasAuth(() => request.put('barras/ciclicos/captura', data))
    }
}